{
  "title": "Edit profile",
  "subtitle": "Manage your personal information, password and collaborators.",
  "tabs": {
    "personalInformation": "Personal information",
    "password": "Password",
    "collaborators": "Collaborators"
  },
  "form": {
    "emailLogin": "Login email",
    "phone": "Phone",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "confirmPassword": "Confirm password"
  },
  "placeholders": {
    "phone": "Phone",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "confirmPassword": "Confirm password"
  },
  "buttons": {
    "validate": "Validate",
    "validatePassword": "Validate password",
    "updateCollaborator": "Update collaborator"
  },
  "table": {
    "lastname": "Last name",
    "firstname": "First name",
    "status": "Status"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "pending": "Pending",
    "deleted": "Deleted"
  },
  "searchCollaborators": "Search collaborator",
  "statusFilter": "Status",
  "messages": {
    "success": "Profile updated"
  }
}
